import React, { useEffect, useState } from "react";
import "./Downloads.css";

import pdfIcon from "../../../../assets/images/allsolutions/downloads/pdf.png";
import downloadIcon from "../../../../assets/images/allsolutions/downloads/download.png";
import { useTranslation } from "react-i18next";
import { fetchAllDownloadsDocuments } from "../../../../utils/downloadsDocuments";

const Downloads = () => {
  const { i18n } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      try {
        const all = await fetchAllDownloadsDocuments(i18n.language || "en");
        if (!isMounted) return;
        const solutionDocs = all
          .filter((d) => d.source === "solutions" && d.fileUrl)
          .map((d) => ({
            id: d.id,
            name: d.title || "Document",
            href: d.fileUrl,
          }));
        setItems(solutionDocs);
      } catch {
        if (isMounted) setItems([]);
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [i18n.language]);

  const hasItems = items.length > 0;

  const handleOpen = (href) => {
    if (!href) return;
    window.open(href, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="downloads">
      <div className="downloads-container">
        <div className="downloads-tag">DOWNLOADS</div>

        <h1 className="downloads-title">Available downloads</h1>

        <p className="downloads-desc">
          {hasItems
            ? "Technical PDFs from our solutions — open or download from the list below."
            : "No solution PDFs are available at the moment. Check back later."}
        </p>

        <div className="downloads-list">
          {items.map((item, index) => (
            <button
              key={item.id}
              type="button"
              className={`downloads-item ${index === 0 ? "active" : ""}`}
              onClick={() => handleOpen(item.href)}
            >
              <div className="downloads-left">
                <img src={pdfIcon} alt="" aria-hidden />
                <span>{item.name}</span>
              </div>

              <div className="downloads-right" aria-hidden>
                <img src={downloadIcon} alt="" />
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Downloads;
